import fetchQuery from '../api/fetchQuery'
import applyQueryToUrl from '../utils/applyQueryToUrl'
import {fromApi} from '../utils/apiMapper'
import {defineMessages} from 'react-intl'

import addNotification from './addNotification'

import executeQuery from './executeQuery'
import toggleMyQueriesModal from './toggleMyQueriesModal'

const messages = defineMessages({
  title: {
    id: 'An error happend', 
    defaultMessage: 'An error happened'
  },
  message: {
    id: "The retrival of the query couldn't complete, try again later", 
    defaultMessage: "The retrival of the query couldn't complete, try again later"
  }
})
const notification = {type: "error", message: messages.message, title: messages.title} 

const onComplete = (dispatch, suggestions) => (err, query) => {
  if(err) {
    dispatch(addNotification(notification))
    return console.error("Failed to execute saved query", err)
  }
  dispatch(toggleMyQueriesModal())
  const q = fromApi(query, suggestions)
  applyQueryToUrl(q)
  dispatch(executeQuery(q))
}

export default (queryId) => (dispatch, getState) => {
  const {token, userName} = getState().session
  const suggestions = getState().suggestions;
  fetchQuery(userName, token, queryId, onComplete(dispatch, suggestions))
}



/** WEBPACK FOOTER **
 ** ./app/actions/executeSavedQuery.js
 **/